export const ROUTES = {
    SELL: '/sell',
    COMPANY: '/company',
    SEARCH: '/search',
    PARTS: '/parts',
    CHECKAUTO: '/checkauto',
    REGION_SERVICE: '/region-service',
    PLACEMENT: '/placement',
    ACCOUNT: '/account',
    RENT: '/rent',
    TOOLS: '/tools',
};

const sellRoute = (route) => `${ROUTES.SELL}/${route}`;
const companyRoute = (route) => `${ROUTES.COMPANY}/${route}`;
const searchRoute = (route) => `${ROUTES.SEARCH}/${route}`;
const partsRoute = (route) => `${ROUTES.PARTS}/${route}`;
const checkautoRoute = (route) => `${ROUTES.CHECKAUTO}/${route}`;
const regionRoute = (route) => `${ROUTES.REGION_SERVICE}/${route}`;
const placementRoute = (route) => `${ROUTES.PLACEMENT}/${route}`;
const accountRoute = (route) => `${ROUTES.ACCOUNT}/${route}`;
const rentRoute = (route) => `${ROUTES.RENT}/${route}`;
const toolsRoute = (route) => `${ROUTES.TOOLS}/${route}`;

const toolsRoutes = {
    CUSTOMS_CALCULATOR: toolsRoute('customs-calculator'),
    CUSTOMS_CALCULATOR_COUNTRY: toolsRoute('customs-calculator/:country'),
    RE_REGISTRATION: toolsRoute('re-registration'),
    VALUATOR: toolsRoute('valuator'),
    AVERAGE_PRICE_TYPE_BRAND_MODEL: '/average-price/:type/:brand/:model',
    AVERAGE_PRICE_TYPE_BRAND_MODEL_YEAR:
        '/average-price/:type/:brand/:model/:year',
    MODEL_GUIDE: '/guide/:type/:brand/:model',
    PRICING: '/pricing',
    MARKET: '/market',
};

const companyRoutes = {
    DEALER: companyRoute('dealer'),
    AUTOCOMPANY: companyRoute('autocompany'),
    RENTCOMPANY: companyRoute('rentcompany'),
    PARTSCOMPANY: companyRoute('partscompany'),
    SERVICE: companyRoute('service'),
    EXPERT: companyRoute('expert'),
    INSURANCE: companyRoute('insurance'),
    RENT_ID: companyRoute('rent/:id'),
    DEALER_ID: companyRoute('dealer/:id'),
    AUTOCOMPANY_ID: companyRoute('autocompany/:id'),
    PARTS_ID: companyRoute('parts/:id'),
    EXPERT_ID: companyRoute('expert/:id'),
    INSURANCE_ID: companyRoute('insurance/:id'),
    SERVICE_ID: companyRoute('service/:id'),
    GET_ALL_ID: companyRoute('get/all/:id'),
};

const sellRoutes = {
    CAR: sellRoute('car'),
    CAR_ID: sellRoute('car/:id'),
    ALL_CAR: sellRoute('all/car'),
    ALL_CAR_ID: sellRoute('all/car/:id'),
    PRO_CAR: sellRoute('pro/car'),
    BIKE: sellRoute('bike'),
    BIKE_ID: sellRoute('bike/:id'),
    ALL_BIKE: sellRoute('all/bike'),
    ALL_BIKE_ID: sellRoute('all/bike/:id'),
    PRO_BIKE: sellRoute('pro/bike'),
    COMMERCIAL: sellRoute('commercial'),
    COMMERCIAL_ID: sellRoute('commercial/:id'),
    ALL_COMMERCIAL: sellRoute('all/commercial'),
    ALL_COMMERCIAL_ID: sellRoute('all/commercial/:id'),
    PRO_COMMERCIAL: sellRoute('pro/commercial'),
};

const searchRoutes = {
    CAR: searchRoute('car'),
    CAR_CITY: searchRoute('car/:city'),
    CAR_PRICE: searchRoute('car/price/:range'),
    CAR_BRAND: searchRoute('car/brand/:brand'),
    CAR_BRAND_MODEL: searchRoute('car/brand/:brand/model/:model'),
    CAR_BRAND_MODEL_YEAR: searchRoute('car/brand/:brand/model/:model/:year'),
    CAR_BRAND_CITY: searchRoute('car/brand/:brand/:city'),
    CAR_BRAND_MODEL_CITY: searchRoute('car/brand/:brand/:model/:city'),
    CABINET_CAR: searchRoute('cabinet/car'),
    FULL_CAR: searchRoute('full/car'),
    BIKE: searchRoute('bike'),
    BIKE_CITY: searchRoute('bike/:city'),
    BIKE_BRAND: searchRoute('bike/brand/:brand'),
    BIKE_BRAND_MODEL: searchRoute('bike/brand/:brand/model/:model'),
    BIKE_BRAND_MODEL_YEAR: searchRoute('bike/brand/:brand/model/:model/:year'),
    BIKE_BRAND_CITY: searchRoute('bike/brand/:brand/:city'),
    BIKE_BRAND_MODEL_CITY: searchRoute('bike/brand/:brand/:model/:city'),
    CABINET_BIKE: searchRoute('cabinet/bike'),
    FULL_BIKE: searchRoute('full/bike'),
    COMMERCIAL: searchRoute('commercial'),
    COMMERCIAL_CITY: searchRoute('commercial/:city'),
    COMMERCIAL_BRAND: searchRoute('commercial/brand/:brand'),
    COMMERCIAL_BRAND_MODEL: searchRoute('commercial/brand/:brand/model/:model'),
    COMMERCIAL_BRAND_MODEL_YEAR: searchRoute('commercial/brand/:brand/model/:model/:year'),
    COMMERCIAL_BRAND_CITY: searchRoute('commercial/brand/:brand/:city'),
    COMMERCIAL_BRAND_MODEL_CITY: searchRoute('commercial/brand/:brand/:model/:city'),
    CABINET_COMMERCIAL: searchRoute('cabinet/commercial'),
    FULL_COMMERCIAL: searchRoute('full/commercial'),
    COMPANY: searchRoute('company'),
    COMPANY_CITY: searchRoute('company/:city'),
    COMPANY_TYPE: searchRoute('company/type/:type'),
    FULL_COMPANY: searchRoute('full/company'),
    CHECKAUTO: searchRoute('checkauto'),
    FULL_CHECKAUTO: searchRoute('full/checkauto'),
    PARTS: searchRoute('parts/parts'),
    PARTS_CAR: searchRoute('parts/car'),
    PARTS_BIKE: searchRoute('parts/bike'),
    PARTS_COMMERCIAL: searchRoute('parts/commercial'),
    FULL_PARTS_ALL: searchRoute('full/parts/parts'),
    CABINET_PARTS_ALL: searchRoute('cabinet/parts/parts'),
    FULL_PARTS_CAR: searchRoute('full/parts/car'),
    CABINET_PARTS_CAR: searchRoute('cabinet/parts/car'),
    FULL_PARTS_BIKE: searchRoute('full/parts/bike'),
    CABINET_PARTS_BIKE: searchRoute('cabinet/parts/bike'),
    FULL_PARTS_COMMERCIAL: searchRoute('full/parts/commercial'),
    CABINET_PARTS_COMMERCIAL: searchRoute('cabinet/parts/commercial'),
    PLACEMENT: searchRoute('placement'),
    FULL_PLACEMENT: searchRoute('full/placement'),
    SERVICE: searchRoute('service'),
    FULL_SERVICE: searchRoute('full/service'),
    RENT_CAR: searchRoute('rent/car'),
    RENT_CAR_CITY: searchRoute('rent/car/:city'),
    RENT_CAR_BRAND: searchRoute('rent/car/brand/:brand'),
    RENT_CAR_BRAND_CITY: searchRoute('rent/car/brand/:brand/:city'),
    CABINET_RENT_CAR: searchRoute('cabinet/rent/car'),
    FULL_RENT_CAR: searchRoute('full/rent/car'),
    RENT_BIKE: searchRoute('rent/bike'),
    RENT_BIKE_CITY: searchRoute('rent/bike/:city'),
    RENT_BIKE_BRAND: searchRoute('rent/bike/brand/:brand'),
    RENT_BIKE_BRAND_CITY: searchRoute('rent/bike/brand/:brand/:city'),
    CABINET_RENT_BIKE: searchRoute('cabinet/rent/bike'),
    FULL_RENT_BIKE: searchRoute('full/rent/bike'),
    RENT_COMMERCIAL: searchRoute('rent/commercial'),
    RENT_COMMERCIAL_CITY: searchRoute('rent/commercial/:city'),
    RENT_COMMERCIAL_BRAND: searchRoute('rent/commercial/brand/:brand'),
    RENT_COMMERCIAL_BRAND_CITY: searchRoute('rent/commercial/brand/:brand/:city'),
    CABINET_RENT_COMMERCIAL: searchRoute('cabinet/rent/commercial'),
    FULL_RENT_COMMERCIAL: searchRoute('full/rent/commercial'),
    SERVICE_CITY: searchRoute('service/:city'),
    SERVICE_TYPE: searchRoute('service/type/:type'),
    PLACEMENT_CITY: searchRoute('placement/:city'),
    PLACEMENT_TYPE: searchRoute('placement/type/:type'),
    CHECKAUTO_CITY: searchRoute('checkauto/:city'),
    PARTS_CITY: searchRoute('parts/parts/:city'),
    PARTS_CAR_CITY: searchRoute('parts/car/:city'),
    PARTS_BIKE_CITY: searchRoute('parts/bike/:city'),
    PARTS_COMMERCIAL_CITY: searchRoute('parts/commercial/:city'),
};

const partsRoutes = {
    ADD: partsRoute('add'),
    ALL_ID: partsRoute('all/:id'),
    ALL: partsRoute('all'),
    ACCESSORY_ID: partsRoute('accessory/advert/:id'),
    CARBODY_ID: partsRoute('carbody/advert/:id'),
    MAINTENANCE_ID: partsRoute('maintenance/advert/:id'),
    BRAKES_ID: partsRoute('brakes/advert/:id'),
    WHEELS_ID: partsRoute('wheels/advert/:id'),
    TRANSMISSION_ID: partsRoute('transmission/advert/:id'),
    SUSPENSION_ID: partsRoute('suspension/advert/:id'),
    GAS_ID: partsRoute('gas/advert/:id'),
    INTERIOR_ID: partsRoute('interior/advert/:id'),
    EQUIPMENT_ID: partsRoute('equipment/advert/:id'),
    ENGINE_ID: partsRoute('engine/advert/:id'),
    ELECTRIC_ID: partsRoute('electric/advert/:id'),
    HEATING_ID: partsRoute('heating/advert/:id'),
};

const checkautoRoutes = {
    REPORT: checkautoRoute('report'),
    EXAMPLE: checkautoRoute('example'),
};

const rentRoutes = {
    CAR: rentRoute('car'),
    CAR_ID: rentRoute('car/:id'),
    BIKE: rentRoute('bike'),
    BIKE_ID: rentRoute('bike/:id'),
    COMMERCIAL: rentRoute('commercial'),
    COMMERCIAL_ID: rentRoute('commercial/:id'),
    ALL_ID: rentRoute('all/:id'),
    ALL: rentRoute('all'),
};

const regionServiceRoutes = {
    AUTOSERVICE: regionRoute('autoservice'),
    AUTOSERVICE_ID: regionRoute('autoservice/advert/:id'),
    AUTOSCHOOL: regionRoute('autoschool'),
    AUTOSCHOOL_ID: regionRoute('autoschool/advert/:id'),
    DISASSEMBLY: regionRoute('disassembly'),
    DISASSEMBLY_ID: regionRoute('disassembly/advert/:id'),
    CARWASH: regionRoute('carwash'),
    CARWASH_ID: regionRoute('carwash/advert/:id'),
    INSURANCE: regionRoute('insurance'),
    INSURANCE_ID: regionRoute('insurance/advert/:id'),
    TYRESERVICE: regionRoute('tyreservice'),
    TYRESERVICE_ID: regionRoute('tyreservice/advert/:id'),
    PAINTING: regionRoute('painting'),
    PAINTING_ID: regionRoute('painting/advert/:id'),
    TOWTRUCK: regionRoute('towtruck'),
    TOWTRUCK_ID: regionRoute('towtruck/advert/:id'),
    ALL_ID: regionRoute('all/:id'),
    ALL: regionRoute('all'),
};

const placementRoutes = {
    AUTOSERVICE: placementRoute('autoservice'),
    AUTOSERVICE_ID: placementRoute('autoservice/advert/:id'),
    BOX: placementRoute('box'),
    BOX_ID: placementRoute('box/advert/:id'),
    CARWASH: placementRoute('carwash'),
    CARWASH_ID: placementRoute('carwash/advert/:id'),
    CARPAINT: placementRoute('carpaint'),
    CARPAINT_ID: placementRoute('carpaint/advert/:id'),
    GARAGE: placementRoute('garage'),
    GARAGE_ID: placementRoute('garage/advert/:id'),
    PAINTING: placementRoute('painting'),
    PAINTING_ID: placementRoute('painting/advert/:id'),
    TYRESERVICE: placementRoute('tyreservice'),
    TYRESERVICE_ID: placementRoute('tyreservice/advert/:id'),
    ALL_ID: placementRoute('all/:id'),
    ALL: placementRoute('all'),
};

const accountRoutes = {
    TERMS_CONDITIONS: '/terms',
    PRIVACY: '/privacy',
    ABOUT: '/about',
    CONTACTS: '/contacts',
    PARTNERS: '/partners',
    PARTNERS_TOKEN: '/partners/:token',
    UNSUBSCRIBE_TOKEN: '/unsubscribe/:token',
    NUDGE_TOKEN: accountRoute('nudge/:token'),
    NUDGE_UNSUBSCRIBE_TOKEN: accountRoute('nudge-unsubscribe/:token'),
    SAVED_SEARCH_UNSUBSCRIBE_TOKEN: accountRoute('saved-search-unsubscribe/:token'),
    LOGIN: accountRoute('login'),
    SIGNUP_USER: accountRoute('signup/user'),
    SIGNUP_DEALER: accountRoute('signup/dealer'),
    SIGNUP_CORPORATE: accountRoute('signup/corporate'),
    CABINET: accountRoute('cabinet'),
    IMPORT: accountRoute('import'),
    SETTINGS: accountRoute('settings'),
    PAYMENT_HISTORY: accountRoute('payment-history'),
    VERIFICATE: accountRoute('verificate'),
    COMPANY: accountRoute('company'),
    FAVORITE_PARTS: accountRoute('favorites/parts'),
    FAVORITE_CAR: accountRoute('favorites/car'),
    FAVORITE_BIKE: accountRoute('favorites/bike'),
    FAVORITE_COMMERCIAL: accountRoute('favorites/commercial'),
    GARAGE_CAR: accountRoute('garage/car'),
    GARAGE_BIKE: accountRoute('garage/bike'),
    GARAGE_COMMERCIAL: accountRoute('garage/commercial'),
    RENT_CAR: accountRoute('rent/car'),
    RENT_BIKE: accountRoute('rent/bike'),
    RENT_COMMERCIAL: accountRoute('rent/commercial'),
    CHECKAUTO_CAR: accountRoute('checkauto/car'),
    CHECKAUTO_BIKE: accountRoute('checkauto/bike'),
    CHECKAUTO_COMMERCIAL: accountRoute('checkauto/commercial'),
    PLACEMENT: accountRoute('placement'),
    SERVICES: accountRoute('services'),
    PARTS: accountRoute('parts'),
    PARTS_CAR: accountRoute('parts/car'),
    PARTS_BIKE: accountRoute('parts/bike'),
    PARTS_COMMERCIAL: accountRoute('parts/commercial'),
    FORGOT_PASSWORD: accountRoute('forgot/password'),
    NEW_PASSWORD: accountRoute('new/password'),
    NEW_PHONE: accountRoute('new/phone'),
    SELL_TOPS_ID: accountRoute('sell/tops/:id'),
    RENT_TOPS_ID: accountRoute('rent/tops/:id'),
    COMPANY_TOPS_ID: accountRoute('company/tops/:id'),
    SERVICES_TOPS_ID: accountRoute('services/tops/:id'),
    PLACEMENT_TOPS_ID: accountRoute('placement/tops/:id'),
    PARTS_TOPS_ID: accountRoute('parts/tops/:id'),
};

export {
    accountRoutes,
    checkautoRoutes,
    companyRoutes,
    partsRoutes,
    placementRoutes,
    regionServiceRoutes,
    rentRoutes,
    searchRoutes,
    sellRoutes,
    toolsRoutes,
};
